import { getCookieValue, setCookieValue } from "@/utils/cookies";
import { getUtmsCookies } from "@/utils/UTM";
import { removeNullProperties } from "@/utils/objects";
import { buildFormToSubmit } from "@/utils/Form/formatData";
import { getSlugByPdfId } from "@/utils/Form/formUtils";
import { cleanOptionalKeys } from "@/hooks/useFormUtils";
import { Addon } from "@/templates/types";
import * as log from "@/actions/logger";

type Language = "es" | "en-US";

export const createOrUpdateApplication = async ({
  applicationValues,
  pdfId,
  language,
  formDetails,
  siteAddons,
  requestPostCreateApplication,
  requestPutEditApplication,
  requestGetApplicationName,
}: {
  applicationValues: Record<string, any>;
  pdfId: string;
  language: Language;
  formDetails: any;
  siteAddons?: Addon[] | null;
  requestPostCreateApplication: (args: any) => Promise<any>;
  requestPutEditApplication: (args: any) => Promise<any>;
  requestGetApplicationName: (args: any) => Promise<any>;
}) => {
  const utmCookies = getUtmsCookies();
  const orderCookie = getCookieValue("address_token");
  const valuesWithoutOptionalKeys = cleanOptionalKeys(applicationValues);
  const cleanApplicationValues = removeNullProperties(valuesWithoutOptionalKeys);

  const formDataForApi = {
    ...utmCookies,
    ...buildFormToSubmit({ ...cleanApplicationValues, pdfId, language }, siteAddons),
    applicationId: orderCookie?.applicationId,
  };

  try {
    let response: any = null;
    if (
      orderCookie &&
      typeof orderCookie.applicationId === "string" &&
      orderCookie.pdfId === pdfId
    ) {
      response = await requestPutEditApplication({
        applicationId: orderCookie.applicationId,
        formData: formDataForApi,
      });
    } else {
      response = await requestPostCreateApplication({ formData: formDataForApi });
      const { data: appNameResponse } = await requestGetApplicationName({
        applicationId: response?.data.id,
      });

      const {
        pdf: { name, description },
        price,
      } = formDetails;

      setCookieValue("address_token", {
        application: {
          formName: name,
          formDescription: description,
        },
        regularPrice: {
          name: getSlugByPdfId(pdfId),
          amount: price,
        },
        paymentSite: appNameResponse.paymentSiteWithPrefix,
        originalSite: appNameResponse.originalSiteWithPrefix,
        applicationId: response?.data.id,
        pdfId: pdfId,
        order: response?.data.id,
      });
    }

    return response;
  } catch (error) {
    log.error(
      { err: error, module: "createOrUpdateApplication" },
      "createOrUpdateApplication error"
    );
    throw error;
  }
};
